import { API_HEADER, api as axios } from 'js/modules/axios'
import { URLS } from 'modules/axios'
import queryString from 'query-string'
import useApi from 'composables/useApi'

const { stringify } = queryString

export function perguntasService() {
  const api = () => useApi()

  function getPergunta(id, params = {}) {
    const query = stringify(params, {
      skipEmptyString: true,
      skipNull: true,
    })
    return api().query(`${URLS.pergunta}${id}/?${query}`)
  }

  function patchPerguntaEdit(id, data) {
    return api().mutation(
      `${URLS.pergunta}${id}/editar/`,
      'PATCH',
      data
    )
  }

  function getPlanoAcao(params) {
    return api().query(`${URLS.plano_acao}${params}`)
  }

  function postPlanoAcao(data) {
    return api().mutation(`${URLS.plano_acao}`, 'POST', data)
  }

  function patchPlanoAcao(id, data) {
    return api().mutation(`${URLS.plano_acao}${id}/`, 'PATCH', data)
  }

  function getAcompanhamento(params) {
    return api().query(`${URLS.acompanhamento}${params}`)
  }

  function postAcompanhamento(data) {
    return api().mutation(`${URLS.acompanhamento}`, 'POST', data)
  }

  function postAcompanhamentoFile(id, data, config = {}) {
    return axios.post(
      `${URLS.acompanhamento}${id}/salvar_arquivo/`,
      data,
      {
        headers: {
          ...API_HEADER,
          'Content-Type': 'multipart/form-data',
        },
        ...config,
      }
    )
  }

  return {
    getPergunta,
    getPlanoAcao,
    postPlanoAcao,
    patchPerguntaEdit,
    patchPlanoAcao,
    getAcompanhamento,
    postAcompanhamento,
    postAcompanhamentoFile,
  }
}
